import { render, staticRenderFns } from "./PatentListDetail.vue?vue&type=template&id=6e769e28"
import script from "./PatentListDetail.vue?vue&type=script&lang=js"
export * from "./PatentListDetail.vue?vue&type=script&lang=js"
import style0 from "./PatentListDetail.vue?vue&type=style&index=0&id=6e769e28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports